const locationFacilityTypes = {
  create: 'Criar',
  update: 'Atualizar',
  facilityType: {
    school: 'Escola',
    work: 'Local de trabalho',
  },
  toasts: {
    delete: {
      success: '[Location Facility] foi excluído com sucesso',
      errorMessage: 'Algo deu errado. Tente novamente mais tarde.',
    },
    create: {
      success: '[Location Facility] foi criado com sucesso',
      error: '[Location Facility] resposta inválida do servidor',
    },
    update: {
      success: '[Location Facility] foi atualizado com sucesso',
      error: '[Location Facility] resposta inválida do servidor',
    },
  },
  deleteModal: {
    header: 'Excluir instalações',
    body: 'Tem certeza de que deseja excluir {{num}} instalações?',
  },
  table: {
    headers: {
      name: 'Nome',
      type: 'Tipo',
      facilityTypes: 'Tipo',
      contactName: 'Сontato',
      email: 'Email',
      phone: 'Número de telefone',
      address: 'Endereço',
      profile: 'Perfil',
    },
    filters: {
      type: 'Tipo',
    },
    actions: {
      delete: 'Excluir',
    },
  },
  form: {
    tabs: {
      general: 'Informações do local',
      contact: 'Informações de contato',
      hours: 'Horários',
      advancedSettings: 'Preferências',
      holidays: 'Feriados',
    },
    forms: {
      general: {
        header: 'Local {{type}}',
        fields: {
          name: 'Nome de {{type}}',
          address: 'Endereço de {{type}}',
          type: 'Tipo de instalação',
          radius: {
            title: 'Raio de correspondência de endereço',
            description:
              'O raio em metros ou pés (m/ft para métrico/imperial) dentro do qual as reservas são reconhecidas como o local e/ou como espera e retorno.',
          },
        },
      },
      contacts: {
        header: 'Contato: {{index}}',
        fields: {
          comment: 'Comentário',
          address: 'Endereço',
          fax: 'Fax',
          phone: 'Telefone',
          email: 'Email',
          type: 'Tipo',
          name: 'Nome',
        },
        actions: {
          add: 'Adicionar contato +',
        },
      },
      shiftsHours: {
        header: {
          school: 'Horário escolar',
          work: 'Horário de trabalho',
        },
        fields: {
          name: 'Nome',
          status: 'Status',
          start: 'Início',
          end: 'Fim',
          type: {
            title: 'Tipo',
            options: {
              collect: 'Coletar',
              distribute: 'Distribuir',
              both: 'Ambos',
            },
          },
          weekDays: 'Dias da semana',
        },
        actions: {
          add: {
            default: '+ Adicionar',
            school: '+ Adicionar horário escolar',
            work: '+ Adicionar horário de trabalho',
          },
        },
      },
      reservationPreferences: {
        header: 'Preferências de reserva',
        fields: {
          sharedWithOther: 'Compartilhado com outros',
          profile: 'Perfil',
          suppliers: 'Fornecedores',
          service: 'Serviço',
        },
      },
      advancedSettings: {
        header: 'Configurações avançadas',
        fields: {
          consistentPassengerRouting: {
            title: 'Roteamento consistente de passageiros',
            toolTipInformation:
              'Garante que o mesmo grupo de passageiros sempre siga a mesma rota de ida e volta da instalação, otimizando a eficiência da viagem e minimizando confusão.',
          },
          sameDriverForGroup: {
            title: 'Mesmo motorista para o grupo',
            toolTipInformation:
              'Atribui o mesmo motorista para transportar o grupo de passageiros tanto no embarque quanto no desembarque, proporcionando familiaridade e consistência aos passageiros.',
          },
          allowSharedRide: {
            title: 'Permitir viagem compartilhada com outros endereços',
            toolTipInformation:
              'Quando habilitado, esta configuração permite que viagens compartilhadas sejam agrupadas com reservas de outras localidades que tenham rotas consistentes. Se desabilitado, apenas viagens da mesma localidade serão consideradas para agrupamento.',
          },
          tripBoardingTime: {
            title: 'Tempo de embarque',
            toolTipInformation:
              'O tempo necessário para embarcar um passageiro na sua parada (Este parâmetro afetará a duração total da viagem)',
          },
          waitForBoardingTime: {
            title: 'Tempo de espera para embarque',
            toolTipInformation: 'Ao chegar a uma parada, o motorista aguardará até o horário exato de embarque, se necessário.',
          },
          tripDropOffTime: {
            title: 'Tempo de desembarque',
            toolTipInformation:
              'O tempo necessário para desembarcar um passageiro na sua parada (Este parâmetro afetará a duração total da viagem)',
          },
          rules: {
            header: 'Regras de local / perfis',
            rule: 'Regra',
            profiles: 'Perfis',
            addNewRule: '+ Adicionar regra de local / perfil',
          },
          maxDropOffEarly: {
            title: 'Máximo de adiantamento no desembarque',
            toolTipInformation:
              'Número máximo de minutos que um motorista pode chegar mais cedo em relação ao horário de desembarque definido na reserva',
          },
          maxDropOffDelay: {
            title: 'Máximo de atraso no desembarque',
            toolTipInformation:
              'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de desembarque definido na reserva',
          },
          maxBoardingDelay: {
            title: 'Máximo de atraso no embarque',
            toolTipInformation:
              'Número máximo de minutos que um motorista pode se atrasar em relação ao horário de embarque definido na reserva',
          },
          maxBoardingEarly: {
            title: 'Máximo de adiantamento no embarque',
            toolTipInformation:
              'Número máximo de minutos que um motorista pode chegar mais cedo em relação ao horário de embarque definido na reserva',
          },
          maxTripDuration: {
            title: 'Duração máxima da viagem',
            toolTipInformation: 'Duração máxima de uma viagem em minutos',
          },
          maxSinglePassengerTime: {
            title: 'Duração máxima da viagem por passageiro',
            toolTipInformation: 'Duração máxima de uma viagem em minutos por passageiro',
          },
        },
      },
      excludedDrivers: {
        header: 'Motoristas excluídos',
        fields: {
          driversList: 'Lista de motoristas',
          excludedList: 'Lista de excluídos',
        },
      },
      excludedVehicles: {
        header: 'Veículos excluídos',
        fields: {
          vehiclesList: 'Lista de veículos',
          excludedList: 'Lista de excluídos',
        },
      },
      excludeHolidays: {
        header: 'Feriados excluídos',
        fields: {
          holidaysList: 'Lista de feriados',
          excludedList: 'Feriados excluídos',
        },
      },
    },
  },
};

export default locationFacilityTypes;
